import { render, staticRenderFns } from "./duty-add.vue?vue&type=template&id=409a236c&scoped=true"
import script from "./duty-add.vue?vue&type=script&lang=js"
export * from "./duty-add.vue?vue&type=script&lang=js"
import style0 from "./duty-add.vue?vue&type=style&index=0&id=409a236c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409a236c",
  null
  
)

export default component.exports